import { useQuery } from "@tanstack/react-query";
import { backendService } from "../services/backend.service";
import type { DepartmentDataResponse } from "../utils/models";

export const useDepartmentData = (departmentId: string, wantDate: string, timezone: string) => {
	return useQuery<DepartmentDataResponse>({
		queryKey: ["departmentData", departmentId, wantDate, timezone],
		queryFn: async () => {
			const response = await backendService.getDepartmentData(departmentId, wantDate, timezone);
			return response.data;
		},
		enabled: false,
	});
};
